import { inferenceHttp } from '@/lib/api/inference-client';
import { logger } from '@/lib/utils/logger';
import {
  ModelProvidersService,
  ModelProviderResponseDto,
  ModelProviderWhitelistResponseDto,
} from '@inference.engine/api-client/web';

export const getAllModelProviders = async (): Promise<ModelProviderResponseDto[]> => {
  try {
    const response = await ModelProvidersService.getAllProviders({ client: inferenceHttp });
    return response.data ?? [];
  } catch (error) {
    logger.error('Failed to fetch model providers:', error);
    return [];
  }
};

export const getWhitelistedProviders = async (): Promise<ModelProviderWhitelistResponseDto[]> => {
  try {
    const response = await ModelProvidersService.getWhitelist({ client: inferenceHttp });
    return response.data?.data ?? [];
  } catch (error) {
    logger.error('Failed to fetch whitelisted providers:', error);
    return [];
  }
};

export const updateWhitelist = async (providers: string[], workspaceId?: string): Promise<void> => {
  try {
    await ModelProvidersService.updateWhitelist({
      client: inferenceHttp,
      body: { providers, workspaceId },
    });
  } catch (error) {
    logger.error('Failed to update whitelist:', error);
    throw error;
  }
};
